import React from "react";
import "./styles.css"; // Import your styles file

const Hero = () => {
  return (
    <div className="">
      <div className="main-img top-margin">
        <div className="text-light main-heading">
    
        </div>
      </div>
    </div>
  );
};

export default Hero;
